<template>
	<div class="message-img-wrap">
		<message-date :created-at="createdAt" />
		<img
			:src="imageUrl"
			@load="showPlaceholder = false"
			v-show="!showPlaceholder"
			class="message-img"
			@click="openImg()"
		/>
		<placeholder-img v-if="showPlaceholder" />
		<message-Image-controls :imageUrl="imageUrl" />
		<dialog-image v-if="showFullImg" @close="hideFullImg()" :image-url="imageUrl" />
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MessageImageControls from '@/components/MessageControls.vue'
import MessageDate from '@/components/ui/MessageDate.vue'
import DialogImage from '@/components/dialogs/DialogImage.vue'
import PlaceholderImg from '@/components/ui/PlaceholderImg.vue'

const showFullImg = ref<boolean>(false)
const showPlaceholder = ref<boolean>(true)

defineProps({
	imageUrl: { type: String, requried: true },
	createdAt: { type: String, default: '' }
})

function openImg() {
	showFullImg.value = true
}

function hideFullImg() {
	showFullImg.value = false
}
</script>

<style lang="scss" scoped>
.message-img {
	width: 100%;
	object-fit: cover;
	border-radius: var(--radius-lg);
	transition: $transition-opacity;
	cursor: pointer;
	@media (min-width: $screen-mobile) {
		&:hover {
			opacity: 0.8;
		}
		&:active {
			opacity: 1;
		}
	}
	&-wrap {
		width: 100%;
		margin-top: 8px;
		margin-bottom: 24px;
	}
}

.dialog {
	&-backdrop {
		position: fixed;
		left: 0;
		bottom: 0;
		background: var(--overlay);
		width: 100%;
		height: 100%;
		z-index: 999;
		@include flex-column-center;
	}
	&-wrap {
		padding: 16px;
		width: calc(100% - 48px);
		height: calc(100% - 48px);
		@include flex-column-center;
		&-img {
			max-width: 100%;
			max-height: 100%;
			border-radius: var(--radius-lg);
			object-fit: contain;
		}
	}
}

.message-controls {
	padding-right: 16px;
}

.message-controls-wrap {
	padding-right: 16px;
}
</style>
